<template>
  <div class="animated fadeIn">
    <b-row v-if="!is_new_zip" >
      <b-col md="3" class="tabtext">
        <span >{{current_zip.ZipCode}}</span>
      </b-col>
      <b-col md="2" class="tabtext">
        <span >{{current_zip.Quantity}}</span>
      </b-col>
      <b-col md="2" class="tabtext">
        <span >{{current_zip.City}}</span>
      </b-col>
      <b-col md="2" class="tabtext">
        <span >{{current_zip.State}}</span>
      </b-col>
      <b-col md="3" class="tabtext">
          <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash clickIcon"
              @click="deleteZip"
            ></i>
        
      </b-col>
    </b-row>
    <b-row v-if="is_new_zip" >
      <b-col md="3" class="tabtext">
        
                  <b-form-input
                    v-model="current_zip.ZipCode"
                    placeholder="Add Zip"
                    autocomplete="off"
                    type="text"
                    id="NewZip"
                    v-mask="'#####'"
                    
                  ></b-form-input>
        
      </b-col>
      <b-col md="3" class="tabtext">
          <i 
              v-b-tooltip
              title="Add"
              class="fa fa-plus clickIcon"
              @click="saveField"
             v-if="current_zip.ZipCode.length == 5"
            ></i>
        
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "RotationZipRow",
  components: {},
  props: {
    rotation_object: { type: Object },   
    zip_object: { type: String }, 
    is_new: {type: Boolean}
  },
  data() {
    return {
      current_rotation: this.rotation_object,
      current_zip: this.zip_object,
      is_new_zip: this.is_new
    };
  },
  methods: {
    saveField: function (event) {
       var _operation = {
        RotationID: this.current_rotation.RotationID,
        ZipCode: this.current_zip.ZipCode,
        Zip: this.current_zip,
        Include: true,
        Rotation: this.current_rotation
      };
      this.$store.dispatch("zip/setFullRotationZipStatus", _operation).then(this.current_zip.ZipCode= '');
    },
    deleteZip: function (event) {
       var _operation = {
        RotationID: this.current_rotation.RotationID,
        ZipCode: this.current_zip.ZipCode,
        Zip: this.current_zip,
        Include: false,
        Rotation: this.current_rotation
      };
      this.$store.dispatch("zip/setFullRotationZipStatus", _operation).then();
    }
  },
  computed: {
    ...mapState(["seminar", "territory", "n_user"]),
  },
  created() {
    //console.log(this.current_zip);

  },
  watch: {
    // "current_seminar.Filters.length": function() {
        // }
  },
  mounted() {},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
hr {
  border: none;
  border-top: 1px dotted #333;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
}
</style>
